import TextControl from './controls/TextControl';
import TinyMCEControl from './controls/TinyMCEControl';
import ImageControl from './controls/ImageControl';
import TextareaControl from './controls/TextareaControl';
import UrlControl from './controls/UrlControl';
import SelectControl from './controls/SelectControl';
import RepeaterControl from './controls/RepeaterControl';
import RadioControl from './controls/RadioControl';
import Slide from './Slide';
import templateManager from './templates';
import AttachmentControl from './controls/AttachmentControl';
import AudioControl from './controls/AudioControl';
import VideoControl from './controls/VideoControl';
import ThumbnailsControl from './controls/ThumbnailsControl';
import DurationControl from './controls/DurationControl';
class Manager {

    constructor() {
        this.templateManager = templateManager;
        this.slides = [];
        this.progressData = [];
        this.settings = {};
        this.inEditor = false;
        this.options = {};
    }

    createSlide(template, data = {}, id, duration, name) {
        return new Slide(template, data, id, duration, name);
    }
    getTemplate(type) {
        return this.templateManager.findByType(type);
    }
    setOptions(options) {
        this.options = options;
        this.settings = options.settings;
        return this;
    }
    /**
     * Control type: text, textarea, tinymce, image, attachment, multiple, select, url, duration
     */
    createControl(key, slide, structure, defaultValue, index, reRender, saveValue, runtimeValue, showModalCrop) {
        const type = structure.type;
        let saveControlValue = null;

        if (!saveValue) {
            saveControlValue = (value) => {
                slide.setValue(key, value);
                if (reRender) {
                    reRender()
                }
            }
        } else {
            saveControlValue = (value) => {
                saveValue(value);
                if (reRender) {
                    reRender()
                }
            }
        }

        let controlKey = index;

        if (type === 'text') {
            return <TextControl structure={structure} saveValue={saveControlValue} defaultValue={defaultValue} controlKey={controlKey} runtimeValue={runtimeValue} key={controlKey} />
        }
        if (type === 'tinymce') {
            return <TinyMCEControl structure={structure} saveValue={saveControlValue} defaultValue={defaultValue} controlKey={controlKey} key={controlKey} />
        }
        if (type === 'image') {
            return <ImageControl structure={structure} saveValue={saveControlValue} defaultValue={defaultValue} controlKey={controlKey} runtimeValue={runtimeValue} showModalCrop={showModalCrop} key={controlKey} />
        }
        if (type === 'textarea') {
            return <TextareaControl structure={structure} saveValue={saveControlValue} defaultValue={defaultValue} controlKey={controlKey} key={controlKey} />
        }
        if (type === 'url') {
            return <UrlControl structure={structure} saveValue={saveControlValue} defaultValue={defaultValue} controlKey={controlKey} selectedSlide={slide} key={controlKey} />
        }
        if (type === 'duration') {
            return <DurationControl structure={structure} saveValue={saveControlValue} defaultValue={defaultValue} controlKey={controlKey} selectedSlide={slide} key={controlKey} />
        }
        if (type === 'select') {
            return <SelectControl structure={structure} saveValue={saveControlValue} defaultValue={defaultValue} controlKey={controlKey} key={controlKey} />
        }
        if (type === 'repeater') {
            return <RepeaterControl structure={structure} saveValue={saveControlValue} defaultValue={defaultValue} structureKey={key} selectedSlide={slide} selectedSlideIndex={index} parentReRender={reRender} controlKey={controlKey} showModalCrop={showModalCrop} key={controlKey} />
        }
        if (type === 'radio') {
            return <RadioControl structure={structure} saveValue={saveControlValue} defaultValue={defaultValue} controlKey={controlKey} runtimeValue={runtimeValue} selectedSlide={slide} key={controlKey} />
        }
        if (type === 'attachment') {
            return <AttachmentControl structure={structure} saveValue={saveControlValue} defaultValue={defaultValue} controlKey={controlKey} selectedSlide={slide} runtimeValue={runtimeValue} key={controlKey} />
        }
        if (type === 'audio') {
            return <AudioControl structure={structure} saveValue={saveControlValue} defaultValue={defaultValue} controlKey={controlKey} selectedSlide={slide} runtimeValue={runtimeValue} key={controlKey} />
        }
        if (type === 'video') {
            return <VideoControl structure={structure} saveValue={saveControlValue} defaultValue={defaultValue} controlKey={controlKey} selectedSlide={slide} selectedSlideIndex={index} runtimeValue={runtimeValue} key={controlKey} />
        }
        if (type === 'thumbnails') {
            return <ThumbnailsControl structure={structure} saveValue={saveControlValue} defaultValue={defaultValue} controlKey={controlKey} selectedSlide={slide} selectedSlideIndex={index} runtimeValue={runtimeValue} showModalCrop={showModalCrop} key={controlKey} />
        }

        return (
            <div></div>
        );
    }

    async runAsPromise(func, ...args) {
        return new Promise((resolve, reject) => {
            const result = func(...args);

            if (result instanceof Promise) {
                // Jika result adalah promise, tunggu hasilnya
                result
                    .then(resolve)
                    .catch(reject);
            } else {
                // Jika result bukan promise, resolusi langsung dengan hasilnya
                resolve(result);
            }
        });
    }

}

const manager = new Manager();

export default manager;
